import { useFormik } from "formik";
import * as Yup from "yup";
import { FC } from "react";
import { InputDatePickerTimeDisplayModeEnum, PageEnum } from "../../models";
import {
  ErrorValidationBox,
  TextBox,
  LoadingBox,
  InputDatePicker,
  ButtonBox,
} from "..";
import { getLabelName, isArabicCurrentLanguage } from "../../utils";
import { Checkbox } from "antd";
import { PrivilegesChecker } from "..";

import { useFormActions } from "../../hooks/transactionDueDate/useFormActions";

export const TransactionDueDateForm: FC = () => {
  // Use our consolidated hook
  const { data, loading, errors, saveData, clearErrorsAndId } =
    useFormActions();

  const validationSchema = Yup.object({});
  const isArabic = isArabicCurrentLanguage();

  // Form handling with Formik
  const formik = useFormik({
    initialValues: data || {},
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      const success = await saveData(values);
      if (success) {
        resetForm();
      }
    },
    validateOnChange: false,
    validateOnBlur: false,
  });

  if (loading && !data) {
    return <LoadingBox />;
  }
  return (
    <>
      {loading && <LoadingBox />}
      {<ErrorValidationBox errors={errors} />}

      <form className="forms-sample" onSubmit={formik.handleSubmit}>
        <div className=" row row-cols-1 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-1 row-cols-sm-1 g-md-4 g-sm-4">
          <TextBox
            key="Transaction_ID"
            labelName={getLabelName("identity")}
            inputName="Transaction_ID"
            placeHolder={getLabelName("code")}
            isReadOnly
            inputValue={formik.values?.Transaction_ID}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            errorText={formik.errors?.Transaction_ID?.toString() ?? undefined}
          />

          <TextBox
            key={`customerName_${isArabic ? "Ar" : "En"}`}
            labelName={getLabelName("customerName")}
            isReadOnly
            placeHolder="Name"
            inputName="CusomerNameAr"
            inputValue={formik.values?.[`CusomerName${isArabic ? "Ar" : "En"}`]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            errorText={formik.errors?.[
              `CusomerName${isArabic ? "Ar" : "En"}`
            ]?.toString()}
          />

          <InputDatePicker
            id="datePicker"
            timeMode={InputDatePickerTimeDisplayModeEnum.None}
            selectedDate={new Date(formik.values?.DueDate.toString()!)}
            className="form-control"
            InputLabel="DueDate"
            name="DueDate"
            onChange={(date: Date) => {
              formik.values.DueDate = date;
              if (date) {
                formik.setFieldValue("DueDate", new Date(date));
              }
            }}
          />

          <TextBox
            key="Amount_Due"
            labelName={getLabelName("Amount Due")}
            inputName="Amount_Due"
            errorText={formik.errors.Amount_Due}
            isReadOnly
            inputValue={formik.values?.Amount_Due}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          <TextBox
            key="Amount_Paid"
            labelName={getLabelName("Amount Paid")}
            placeHolder={getLabelName("Amount Paid")}
            inputName="Amount_Paid"
            inputValue={formik.values?.Amount_Paid}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            errorText={formik.errors.Amount_Paid}
            type={"text"}
          />

          <div className="d-flex  align-items-center">
            <div className="d-flex justify-content-around align-items-center">
              <Checkbox
                checked={
                  formik.values?.Amount_Paid >= formik.values?.Amount_Due
                }
                disabled
                id="isPaid"
              />
              <label style={{ marginInlineStart: "8px" }} htmlFor="isPaid">
                {getLabelName("isPaid")}
              </label>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <TextBox
            labelName="Remarks"
            inputName={"Remarks"}
            errorText={formik.errors.Remarks}
            type="textarea"
            inputValue={formik.values?.Remarks}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>

        <div className="row mt-4">
          <div className="col-12 d-flex justify-content-end">
            <PrivilegesChecker
              formId={PageEnum.ManageTransactionDueDate}
              action={data?.ID ? "EnableUpdate" : undefined}
            >
              <ButtonBox
                iconType="content-save"
                type="submit"
                disabled={data?.ID ? false : true}
                className="btn-gradient-primary mx-3"
              >
                {getLabelName(data?.ID ? "Update" : "Select Item")}
              </ButtonBox>
            </PrivilegesChecker>
            <ButtonBox
              iconType="receipt"
              variant="danger"
              type="button"
              onClick={(e) => {
                formik.handleReset(e);
                clearErrorsAndId();
              }}
            >
              {getLabelName("New")}
            </ButtonBox>
          </div>
        </div>
      </form>
    </>
  );
  //#endregion
};
